import { render } from "./pacienteCard.vue?vue&type=template&id=4a0ed83e&scoped=true"
import script from "./pacienteCard.vue?vue&type=script&lang=js"
export * from "./pacienteCard.vue?vue&type=script&lang=js"

import "./pacienteCard.vue?vue&type=style&index=0&id=4a0ed83e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0ed83e"]])

export default __exports__